import FileDownloadApi from './FileDownloadApi';
import FileUploadApi from './FileUploadApi';
import HttpService from './HttpService';

const BulkTransactionsApi = HttpService('/api/bulktransaction/');
const doPost = (action, data) => BulkTransactionsApi.post(action, data);
const doGet = (url) => BulkTransactionsApi.get(url);
const doDelete = (url) => BulkTransactionsApi.delete(url);

export default {
  getBulkTransactionTypes() {
    const apiAction = 'GetBulkTransactionTypes';
    return doGet(apiAction);
  },
  createBulkTransaction(bulkTransaction) {

    if (!bulkTransaction.isValid || bulkTransaction.isValid()) {
      //console.error("Invalid BulkTransactionCreateModel", bulkTransaction);
      //throw "Invalid BulkTransactionCreateModel";
    }

    const apiAction = 'CreateBulkTransaction';
    return doPost(apiAction, bulkTransaction);
  },
  updateBulkTransaction(bulkTransactionUpdate) {

    if (!bulkTransactionUpdate.isValid || bulkTransactionUpdate.isValid()) {
      console.error(bulkTransactionUpdate)
      throw "Invalid UpdateBulkTransactionDto";
    }  

    const apiAction = 'UpdateBulkTransaction';
    return doPost(apiAction, bulkTransactionUpdate);
  },
  deleteBulkTransaction(id) {
    const apiAction = 'DeleteBulkTransaction';
    const queryString = `id=${id}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doDelete(fullUrl);
  },
  getBulkDeliveryNotePdf(bulkTransactionId) {
    const fullUrl = `bulktransaction/GetBulkDeliveryNoteForBulkTransaction?bulkTransactionId=${bulkTransactionId}`;
    return FileDownloadApi().get(fullUrl);
  },
  uploadBulkDeliveryNote(file, bulkTransactionId) {
    const fullUrl = 'bulktransaction/UploadBulkDeliveryNote';

    const formData = new FormData();
    formData.append('file', file);
    formData.append('bulkTransactionId', bulkTransactionId);

    return FileUploadApi().post(fullUrl, formData);
  },
  removeBulkDeliveryNote(bulkTransactionId) {
    const apiAction = 'RemoveBulkDeliveryNote';
    const queryString = `bulkTransactionId=${bulkTransactionId}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;

    return doDelete(fullUrl);
  },
};
